import React from 'react'
import GrantContent from './GrantContent'
import { Link } from 'react-router-dom'
import { Typography } from '@mui/material'

export default function GrantBreadcrumbs({permisos, roles, text, link}) {

    return (
        <GrantContent permisos={permisos} roles={roles} isPage={false}>
            {(canAccess, roles, permisos, isPage) => {
                if (canAccess) {
                    return <Link to={link}>
                        <Typography ><span className="text-gray-600 hover:underline">{text}</span></Typography>
                    </Link>
                } else {
                    return <Typography ><span className="text-gray-600">{text}</span></Typography>
                }
            }}
        </GrantContent>
    )
}